import React from 'react';
import styled from 'styled-components';
import Panel from '@/components/Panel';

export default function Body({ children, ...others }) {
  return <Root {...others}>{children}</Root>;
}

const Root = styled(Panel)`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  .cm-editor {
    height: 300px;
  }
  .t-collapse-panel__header {
    height: 54px;
    box-sizing: border-box;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    background: #f7f8fa;
  }
  .t-collapse-panel__wrapper .t-collapse-panel__content {
    padding: 5px 0;
  }
`;
